import { getDataScopeByPermission, getFacilityByPermission, isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { Component, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';
import { DateTableColumn } from 'src/app/core/models/date-table-column';
import { LaasOption } from 'src/app/core/models/laas-option';
import { PageInfo } from 'src/app/core/models/page-info';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { copyFormControl } from 'src/app/core/utils/validation-functions';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { AnnouncementTableResponse } from './interface/announcement-table-response';
import { AnnouncementService } from '../../service/announcement.service';
import { AnnouncementTableRequest } from './interface/announcement-table-request';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { Table } from 'primeng/table';
import { AnnouncementEditPassParams } from './interface/announcement-edit-paasParams';
import { Dropdown } from 'primeng/dropdown';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { DataViewComponent } from 'src/app/shared/components/data-view/data-view.component';
import { FacilityOptions } from 'src/app/core/models/options/facility-options';
import { UserPreferenceConstants } from '../../../../core/constants/user-preference-constants.constant';
import { endOfDay, startOfDay } from 'date-fns';
import { CalendarComponent } from 'src/app/shared/components/calendar/calendar.component';

export enum DisplayMode {
  Desktop,
  Mobile
}
@Component({
  selector: 'laas-announcement',
  templateUrl: './announcement.component.html',
  styleUrls: ['./announcement.component.scss']
})
export class AnnouncementComponent extends SessionBaseComponent implements OnInit {

  displayMode: DisplayMode = DisplayMode.Desktop;
  readonly DISPLAY_MODE_ENUM = DisplayMode;
  readonly MOBILE_MODE_WINDOW_WIDTH = 770;

  isSearchFormOpen: boolean;

  defaultAnnouncementDt: Date[];
  initAnnouncementStartDtStart: Date;
  initAnnouncementStartDtEnd: Date;

  searchForm: FormGroup;
  pageInfo: PageInfo;
  sortInfo?: [{ property: string; direction: number }];
  first: number;
  isLoading: boolean;


  bookingVendorOptions: any[];

  tableValue: AnnouncementTableResponse[];
  tableColumns: DateTableColumn[];
  selectedTableColumns: DateTableColumn[];
  selectedRow: AnnouncementTableResponse | null;

  facilityOptions: LaasOption[];
  announcementStatusOptions: LaasOption[];
  announcementTypeOptions: LaasOption[];

  passSeqNo: number | null;

  itemMenus: MenuItem[];
  mainItemMenus: MenuItem[];
  // translate
  view: string;
  edit: string;
  cancel: string;
  copy: string;

  actionDropDownList: LaasOption[];

  isAdmin: boolean;
  userFacility: string[];

  readonly newPermissionCode = PermissionConstants.FacilityAnnouncementAdmin;
  readonly preferenceKey: string = UserPreferenceConstants.AnnouncementTableResponse;
  readonly viewPermissionCode = PermissionConstants.ViewFacilityAnnouncement;
  currentLang: string = this.laasSetting.language;

  @ViewChild('ViewTable') viewTable!: Table;
  @ViewChild('LaasDataView') laasDataView!: DataViewComponent;
  @ViewChild('announcementDt') announcementDt!: CalendarComponent;
  constructor(injector: Injector, private formBuilder: FormBuilder, private dropdownOptionsService: DropdownOptionsService,
    private translate: TranslateService, private announcementService: AnnouncementService, private commonDataService: CommonDataService) {
    super(injector);

    let windowResizeEventListener = this.onWindowResize.bind(this);

    window.addEventListener('resize', windowResizeEventListener);

    if (window.innerWidth <= this.MOBILE_MODE_WINDOW_WIDTH) {
      this.changeToMobileMode();
    }

    this.isSearchFormOpen = true;

    this.isLoading = false;

    this.isAdmin = false;

    let now = new Date();
    this.initAnnouncementStartDtEnd = endOfDay(now);
    this.initAnnouncementStartDtStart = startOfDay(now.setMonth(now.getMonth() - 1));

    this.defaultAnnouncementDt = [this.initAnnouncementStartDtStart, this.initAnnouncementStartDtEnd];

    this.searchForm = this.formBuilder.group({
      announcementTitle: null,
      createUser: null,
      announcementStartDtStart: this.initAnnouncementStartDtStart,
      announcementStartDtEnd: this.initAnnouncementStartDtEnd,
      announcementType: null
    });

    this.first = 0;
    this.pageInfo = {
      pageIndex: 0,
      totalPages: 0,
      totalRecords: 0,
      pageSize: 5
    }

    this.bookingVendorOptions = [];
    this.announcementStatusOptions = [];
    this.announcementTypeOptions = [];
    this.facilityOptions = [];

    this.tableValue = [];
    this.tableColumns = this.tableTranslation();
    this.selectedTableColumns = this.tableColumns;
    this.selectedRow = null

    // translate
    this.mainItemMenus = [];
    this.itemMenus = [];

    this.view = '';
    this.edit= '';
    this.cancel = '';
    this.copy = '';

    this.userFacility = [];

    this.passSeqNo = null;

    this.translate.onLangChange.subscribe((e: Event) => {
      this.translationLabel();
    });
    this.translationLabel();

    this.actionDropDownList = [
      { label: this.view, value: 'view' }
    ];
   }

   async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'ANNOUNCEMENT_TYPE').subscribe({
      next: result => {
        this.announcementTypeOptions = [...result].map((option: any) => {
          return {
            label: `${option.codeKey} - ${option.codeDesc}`,
            value: option.codeKey,
          }
        });
      }
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'ANNOUNCEMENT_STATUS').subscribe({
      next: result => {
        this.announcementStatusOptions = [...result].map((option: any) => {
          return {
            label: `${option.codeKey} - ${option.codeDesc}`,
            value: option.codeKey,
          };
        });
      }
    });

    this.dropdownOptionsService.getFacilityOptions().subscribe({
      next: (result) => {
        this.facilityOptions = [...result].map<LaasOption>((option: FacilityOptions) => {
          return {
            label: option.optionDesc,
            value: option.optionCode,
          };
        });
      }
    });

    this.isAdmin = this.permissionCodes.includes(this.newPermissionCode);
    this.laasDataView.showHeader = false;

    await this.getDataScopeFacilityList();
  }

  accordionTabOpen(): void{
    this.isSearchFormOpen = true;
  }

  tablePageChange(event: any) {
    this.pageInfo.pageSize = event.rows;
    this.pageInfo.pageIndex = event.first / this.pageInfo.pageSize;
    this.doSearch();
  }

  tableSort(event: any): void {
    this.resetPageInfo();
    this.sortInfo = [{ property: event.field, direction: event.order }];
    this.doSearch();
  }

  async setPageSize(event: any): Promise<void> {
    await super.ngOnInit();
    this.pageInfo.pageSize = event.rows;
  }

  doSearch() {
    let searchRequest = new AnnouncementTableRequest();
    searchRequest = copyFormControl(this.searchForm, searchRequest);
    searchRequest.pageIndex = this.pageInfo.pageIndex;
    searchRequest.pageSize = this.pageInfo.pageSize;
    searchRequest.sortInfo = this.sortInfo;
    searchRequest.facility = this.laasSetting.facility;
    searchRequest.controlAdmin = this.isAdmin;
    this.isLoading = true;
    this.announcementService.searchAnnouncementTable(searchRequest).subscribe({
      next: (result) => {
        this.isSearchFormOpen = false;
        this.tableValue = result.content;
        this.pageInfo.totalRecords = result.totalElements;
        this.selectedRow = this.tableValue[0];
        this.updateTableHighlight(this.selectedRow);
        this.changeAnnouncementToString();
        this.isLoading = false;
      }
    });
  }

  resetPageInfo() {
    this.pageInfo = {
      pageSize: this.pageInfo.pageSize,
      pageIndex: 0,
      totalRecords: 0,
      totalPages: 0,
    };
    this.first = 0;
  }

  tableTranslation(): DateTableColumn[] {
    var fields: string[];
    var jsons: string[];
    var tmpcolumn: DateTableColumn[] = [];

    fields = ['announcementTitle', 'createUser', 'facility', 'announcementStartDt', 'announcementType', 'status'];

    jsons = ['Announcement.Table.AnnouncementTitle', 'Announcement.Table.CreateUser', 'Announcement.Table.Facility', 'Announcement.Table.AnnouncementDt',
            'Announcement.Table.AnnouncementType', 'Announcement.Table.Status'];

    for (let i = 0; i < fields.length; i++) {
      if (i == 3) {
        tmpcolumn[i] = ({ field: fields[i], header: jsons[i], dataType: 'date' });
      } else {
        tmpcolumn[i] = ({ field: fields[i], header: jsons[i] });
      }

    }
    return tmpcolumn;
  }

  translationLabel() {
    // 檢視
    this.view = this.translateService.instant('Announcement.Action.View');
    // 編輯
    this.edit = this.translateService.instant('Announcement.Action.Edit');
    // 取消
    this.cancel = this.translateService.instant('Announcement.Action.Cancel');
    // 複製
    this.copy = this.translateService.instant('Announcement.Action.Copy');
  }

  changeActionDropDownList(event: any) {
    let passAnnouncementPassParams: AnnouncementEditPassParams;
    switch (event.value) {
      case 'copy': {
        if (this.selectedRow) {
          if (this.selectedRow.seqNo != undefined) {
            passAnnouncementPassParams = {seqNo: this.selectedRow.seqNo , mode: 'copy'};
            this.announcementService.setMessage(passAnnouncementPassParams);
            this.routeStateService.navigateTo('/Setting/FacilityAnnouncementEdit', { passParams: passAnnouncementPassParams });
          }
        }
        break;
      }
      case 'edit': {
        if (this.selectedRow) {
          if (this.selectedRow.seqNo != undefined) {
            passAnnouncementPassParams = { seqNo: this.selectedRow.seqNo , mode: 'edit' };
            this.announcementService.setMessage(passAnnouncementPassParams);
            this.routeStateService.navigateTo('/Setting/FacilityAnnouncementEdit', { passParams: passAnnouncementPassParams });
          }
        }
        break;
      }
      case 'view': {
        if (this.selectedRow) {
          this.routeStateService.navigateTo('/Setting/FacilityAnnouncementView', this.selectedRow.seqNo, true);
        }
        break;
      }
      case 'cancel': {
        if (this.selectedRow) {
          if (this.selectedRow.seqNo) {
            this.announcementService.updateCancelAnnouncement(this.selectedRow.seqNo).subscribe({
              next: (result) => {
                this.toastService.success(this.translateService.instant('Announcement.Toast.CancelSuccess'));
                this.doSearch();
              }
            });
          }
        }
      }
    }
  }

  onRowClick(rowData: AnnouncementTableResponse) {
    if (isNullOrEmpty(this.selectedRow)) {
      this.updateTableHighlight(rowData);
      this.selectedRow = rowData;
    }
    this.actionDropDownList = [{ label: this.view, value: 'view' }];
    if (this.isAdmin && (this.userFacility.includes(rowData.facility!) || this.userFacility.length == 0)) {
      this.actionDropDownList.push({ label: this.copy, value: 'copy' });
    }
    if ((rowData.status == 'U' || rowData.status == 'R') && (this.userFacility.includes(rowData.facility!) || this.userFacility.length == 0)) {
      if (this.isAdmin) {
        this.actionDropDownList.push({ label: this.edit, value: 'edit' });
        this.actionDropDownList.push({ label: this.cancel, value: 'cancel' });
      }
    }
  }

  resetBtnClick() {
    this.announcementDt.ngOnInit();
    this.searchForm.reset({
      announcementStartDtStart: this.initAnnouncementStartDtStart,
      announcementStartDtEnd: this.initAnnouncementStartDtEnd
    });
  }

  searchBtnClick() {
    this.pageInfo.pageIndex = 0;
    this.viewTable.first = this.pageInfo.pageIndex * (this.viewTable.rows ?? 5);
    this.doSearch()
  }

  // Control the selection highlighting back to the row

  private updateTableHighlight(currentRow: AnnouncementTableResponse | null): void {
    if (!currentRow) {
      return;
    }

    this.viewTable.selection = currentRow;

    this.viewTable.selectionKeys = {};

    if (currentRow.seqNo != null) {
      this.viewTable.selectionKeys[currentRow.seqNo] = 1;
    }

    this.viewTable.tableService.onSelectionChange();
  }

  addBtnClick() {
    this.routeStateService.navigateTo('/Setting/FacilityAnnouncementEdit', null);
  }

  cleanActionList(event: any, actionDropDown: Dropdown){
    actionDropDown.clear(event);
  }

  changeAnnouncementToString() {
    if (this.tableValue != null) {
      for (const rowData of this.tableValue) {
        if (rowData.announcementContent != undefined) {
          rowData.announcementContent = rowData.announcementContent.replace(/<[^>]*>/g, '');
        }
      }
    }
  }

  turnToViewAnnouncement(seqNo: number) {
    this.routeStateService.navigateTo('/Setting/FacilityAnnouncementView', seqNo, true);
  }

  onWindowResize() {
    if (window.innerWidth <= this.MOBILE_MODE_WINDOW_WIDTH) {
      this.changeToMobileMode();
    } else {
      this.changeToDesktopMode();
    }
  }

  private changeToMobileMode() {
    this.displayMode = DisplayMode.Mobile
  }

  private changeToDesktopMode() {
    this.displayMode = DisplayMode.Desktop
  }

  isInDesktopMode(): boolean {
    return this.displayMode === this.DISPLAY_MODE_ENUM.Desktop;
  }

  definedStatusColor(statusValue: string): string {
    switch (statusValue) {
      case 'R':
        return 'release-box'
      case 'U':
        return 'unrelease-box'
      case 'C':
        return 'cancel-box'
      case 'E':
        return 'expired-box'
    }
    return 'expired-box'
  }

  checkDataImportant(importFlag: string): boolean{
    if (importFlag == 'Y') {
      return true;
    }
    return false;
  }

  async getDataScopeFacilityList(): Promise<void> {
    const dataScopList = getDataScopeByPermission(this.userProfile, PermissionConstants.FacilityAnnouncementAdmin);
    this.userFacility = dataScopList.map((x:any) =>{ return x.facility; }).filter((x:any) => !isNullOrEmpty(x));
  }

  dateOnChange(date: any, type: string) {
    switch (type) {
      case 'announcementDt':
        this.searchForm.controls.announcementStartDtStart.setValue(date.startDate);
        this.searchForm.controls.announcementStartDtEnd.setValue(date.endDate);
        break;
    }
  }
}

